module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.4144/img/solutions-partner-icon-bordered.svg"